import React, { FC, useCallback, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { toast } from 'react-toastify';

import axios from 'axios';

import { Button, Modal, Textarea, Heading } from '../../shared/ui';
import { useAppSelector } from '../../hooks/redux';
import { selectUser } from '../../store/auth.slice';

import { IConsultation } from '../../store/types';

import { JOURNAL_TAB_GROUP_THERAPY, navigateToJournalSession } from '../../pages/journal/journal-navigation';

import AdBanner from '../ad-banner';

import Header from '../header';

import { UnicornReview } from './unicorn-review';

export const PsychologEnd: FC<{ consultation: IConsultation | null }> = ({ consultation }) => {
  const userData = useAppSelector(selectUser);

  const navigate = useNavigate();
  const [hoverUnicorn, setHoverUnicorn] = useState(0);
  const [note, setNote] = useState('');
  const [unicornActive, setUnicornActive] = useState(0);
  const [isShowModal, setIsShowModal] = useState(false);
  const [isBlocked, setIsBlocked] = useState(false);

  const navigateToTherapeuticJournal = useCallback(() => {
    if (!consultation) return;
    navigateToJournalSession(navigate, consultation.id, consultation.client_entity, 'Инструменты', {
      isClientActive: true,
      journalTabId: consultation.is_group ? JOURNAL_TAB_GROUP_THERAPY : undefined,
    });
  }, [consultation, navigate]);

  const handleSaveReview = async () => {
    try {
      const data = {
        video_score: unicornActive,
        consultation_score: null,
        note: note,
        consultation: consultation ? `/api/v1/consultations/${consultation.id}` : '',
        author: `/api/v1/users/${userData?.id}`,
        client: null,
      };
      const res = await axios.post(`${import.meta.env.VITE_REACT_APP_API_URL}/api/v1/reviews`, data, {});
      if (res.status >= 200 && res.status < 300) {
        setIsShowModal(true);
        setUnicornActive(0);
        setIsBlocked(true);
        setNote('');
      }
    } catch (error) {
      toast.error('Произошла ошибка');
      console.log(error);
    }
  };

  return (
    <div className="w-full h-screen flex flex-col md:flex-row">
      <div className="flex flex-col bg-line-strong items-center justify-center w-full md:max-w-[350px] h-full order-last md:order-first">
        <div className="w-full flex flex-col items-center gap-2.5 pt-[10px]">
          {/* <p className="text-lg font-bold text-ink-muted">Реклама</p> */}
          <AdBanner />
          {/* <div className="flex w-full max-w-[240px] h-[400px] items-center justify-center bg-surface rounded-card lg:rounded-popup" /> */}
        </div>
      </div>
      <div className="w-full">
        {/* <div className="w-full h-headerHeightMobile lg:h-headerHeight bg-white shadow-raised">
          <div className="w-full max-w-[1280px] h-full py-[8px] px-[15px] lg:py-2 mx-auto">
            <div className="h-full flex items-center justify-between">
              <div className="flex flex-col">
                <div className="text-xs md:text-base text-black font-bold leading-3 md:leading-4 mb-[3px] md:mb-[7px]">
                  BETA
                </div>
                <Link to={LANDING}>
                  <LogoIcon className="w-[80px] h-[15px] lg:w-[155px] lg:h-[30px]" />
                </Link>
              </div>
              <button
                className="font-medium flex justify-center py-[6px] lg:py-[10px] px-[30px] bg-ink text-white leading-4 w-max rounded-control hover:text-primary border-2 border-ink active:border-primary active:text-white"
                onClick={onLogout}
              >
                Выйти
              </button>
            </div>
          </div>
        </div> */}
        <Header />
        <div className="pt-6 sm:pt-10 lg:pt-[80px]">
          <div className="pt-6 sm:pt-10 lg:pt-[30px] px-[15px] lg:px-[100px]">
            <Heading size="lg" className="text-center mb-2.5">
              Видео-конференция завершилась
            </Heading>
            <p className="text-ink-muted text-ui lg:text-body-l text-center mb-8">
              ZiNGiZi каждый день старается стать лучше для своих пользователей.
            </p>
            <div className="max-w-[420px] mx-auto bg-white rounded-card lg:rounded-popup p-4 shadow-raised mb-8 sm:mb-14">
              <Button
                size="lg"
                fullWidth
                className="mb-4"
                onClick={() => {
                  setIsShowModal(false);
                  navigateToTherapeuticJournal();
                }}
              >
                Перейти в Терапевтический журнал
              </Button>
              <p className="text-ui-strong lg:text-heading-md text-center text-ink mb-5">
                Оцените качество связи ZiNGiZi
              </p>
              <div className="flex justify-center mb-5 lg:mb-8">
                <UnicornReview
                  hoverUnicorn={hoverUnicorn}
                  unicornActive={unicornActive}
                  setHoverUnicorn={setHoverUnicorn}
                  setUnicornActive={setUnicornActive}
                />
              </div>
              <div className="flex flex-col">
                <Textarea
                  autoGrow
                  className="mb-5 lg:mb-6"
                  value={note}
                  onChange={(event) => setNote(event.target.value)}
                  placeholder="Напишите о качестве работы сервиса"
                  label="Дополнительный комментарий"
                />

                <div className="flex flex-col gap-4 items-center">
                  <Button
                    size="lg"
                    variant="dark"
                    fullWidth
                    disabled={unicornActive === 0 || isBlocked}
                    onClick={() => handleSaveReview()}
                  >
                    Отправить
                  </Button>
                </div>
              </div>
            </div>
          </div>

          <Modal
            isOpen={isShowModal}
            onClose={() => {
              setIsShowModal(false);
              navigateToTherapeuticJournal();
            }}
            size="sm"
            title="Спасибо за отзыв"
            footer={
              <Button
                size="md"
                variant="dark"
                fullWidth
                onClick={() => {
                  setIsShowModal(false);
                  navigateToTherapeuticJournal();
                }}
              >
                Перейти в Терапевтический журнал
              </Button>
            }
          >
            <p className="text-ui text-ink-muted lg:text-body-l">
              Ваш отзыв успешно отправлен. Он поможет улучшить работу сервисов ZiNGiZi.
            </p>
          </Modal>
        </div>
      </div>
    </div>
  );
};
